var _defs, _path, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneRegistrationMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 392,
    height: 321,
    viewBox: "0 0 392 321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    d: "M10,0H228a0,0,0,0,1,0,0V295a0,0,0,0,1,0,0H10A10,10,0,0,1,0,285V10A10,10,0,0,1,10,0Z",
    transform: "translate(0 0.001)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 47"
  }, /*#__PURE__*/React.createElement("image", {
    width: 300,
    height: 47,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAAvCAYAAABZnvdvAAAAAXNSR0IArs4c6QAAIABJREFUeF7tfXmcHFW1//fc2npCMj0BEhYFRAFBXJD4QEQeSCSZnoAoPkCWkOkREJQn4s6iIAooKoqAiMr0JEHwx+KCMD0JW1RQQFEQQRbZRCGBLNNDyHRt9/w+p7q7prq6e6azAfpSf8103br31rm3zj3r99Bwb89JRPg0CFujdjGWgvAEmO+lkIc6Fwz9Pr73Cv5xxwEHmHvs6MxRMA4kwh5g7MKEzcbmyY8w9EldhUV/egWntWmoTRTYRIGNTIGHDn+LvU1m260p1LTaH31hu+t+PypD0khfD080NjP/AYRLs/3FBRO13RD3Vx7+/qwx2fo0gDwRbTdBn7/p7B/cf0OM+3+pj5G+3GeYaUbtnSnEOZ0LBh/bEDQo9ebOBdFOtb406zOmDgw9vT59nwOocwC9Pn00eZYATLj/N/CY/2e6W9U3+x2KjS/Ee4z4vs7+4rfHI8Cq3oP2UGR+johmApgGZgLRCjA/pHX4GRrpy/kAme1QkYF7EYT/m12w6N522q9Lm5HeXB8IF4BoelvPM/+6s1A8oK22TRqN9PZcwEqkNw4AWCBcnO0vFtvpb7iv+6MEOgIMT54lxrWdA8X+dp59tduU8j1/jqTW6qURHtTVv+jWVvNa2dvzNoP4Q2AuZgeG/jDe/Ef6el4EsGXchoN9OwuLf7c+7yzS9p5v7FgIRhZAGK0VcFO2ULy0nX6Xzp212STTXMDgjuh5ounM4cmbpPN2qLdubYZ7uw9XSl07tg/wQGdhMN5z6V6H+2YfoWD8v5ajBfo9VMr3rCJClzRi8GJmWkKEXYh5Boje1uxh1vzJ7EDxknV7jdZPlfK5nxDR0Y0t2AfjLg3cpwjPM9PHifDGqB3jus7C4BHrOpdSvueJuC/IEa5P7+of+no7/ZX6ehYQMLfWlpkXZAvFee08+2q3Gcn3/AKEQydiKsPzej5MCp8mwnuitqE+tHP+0I3jzb+U77mbCHvX2oQB7zl1QfHP6/vOpXzPV4lwVrIf1wu3nXbVoucn6nsk3/0jkDo+XitwyX1p9PXTr1uyeqJnN91fNwqUemd3kzLiw5/BN2b7i2N7LtHt8Lzcm5RBf285EiPsLAyaVOrLPU6oiu/MF3YWirEIF4lnyphLrE4BwU52xsznZgvFs9ftVeqfEnH/tHzPb+OPonqbwX8H8yXeaHj9tJ/e8lztqVK+5zEi7Fxlsj/I9hdPXtd5jORzS0AUq5Ra4+SugcEftNNfqa/72wQlqmt0aeZvdxWKn23n2Ve7TbsMq5TvuSu5LqHW75s6MLTk1WBYMuZIX+4BgN4+xnhwc7Z/8ODx5jM8d9aOyjKfTLbxdLDblgOLH3m11+E/efy1YVilfG6AiOLDnplXgOhsCvWzrPAmBtZ0FYauoJF87g4QRSoVM36XLQzumybiqqMP3MFwMheBcFjdPa0/3zkw9M31JXqaaVTm0pwhrsjP2s4i8x/xmOs5h00Mq3Y6NFfbSvncT4noyBq9wyA8cOqCRXe8Wgxr5XHdbzdN9UDd4an1XuOpqSP53G0gOjBxsBS6CsW+9d23m54fnwJrwbDENPVPgLaNDyLN+2QHinenR6BSPvd9IookFOFiK/WaLXYcWFJuNpXhfO5MRfS1unvraZ8o5XPfJaJT4z4ZoWbkugYGb2k2h1X52YcaZPxi7ITlnnZtTs3628Sw/r0Ylsy2wXTA/FBnofjWpvtl3qz/Ngzz12P32F/94gtd2/7qvjWbGM7GpUC7DOu5ow7YcnJmkkQmGFXB6R/ZwuAOzWYnKuFxBJofnz4TGF/FuwTQtxKdLb+of3CrZh6c4b7uLyqmGaEOL5k6f/Fv0hMoHTd7LzKNe5K/6zB4V9f8xfe1ImUp33MxET5Zva/5pXBa9rpFK9eV9JsY1vgMazif61dE+Rp9/TB86xbzFz20NhKW5nDGhjRuv/iBfac4W2RX1TZ4tMm1Pio7MPTThj2Wz/2diN6UOLk3iv11Xffff/JzbTOsQ2ZMmjxtq5cTtGjp+acXj529jWMbsX2IwRPahEr5OQuJ6NjKAFpsN2d1FYrnJYmf9hCU9Zptpg8sWZpsM5Lv+RsIu8a/tWHQHenL/asmOjLz3dlCcZ/1WfRXg2Gt6u0+wFA0g8GRCEwaS0PNf5xI1Uq/5wu9B2ztYNKBAO8KoiwRr9ZMTxH7v84O3PL4eHQZz4b1fD43zRaXMgAT+BYR5eK+tM77RHVe4hEefTIplaeN7oEfvG3zhYv/KozG2qKzh4C3ATSFmZeB+Z6u+UO3re0alvpynyLQd2JGBKzK9g9uXre/ert7oVQhbsP8dLZQ3HFcZnvc7L2gjH2IeFsGHDCvAvBo2fXv2Oqa25aN9+yKY3KdsPH6WpuQR1em93zt3nOHzJjkbDn9DXF/Hka2+Enxn8n+0/0FZW9FbQ4S+kObme8EsLkCPddMfSr15t5NoPdo4m2JYTDwIoMfcUN959YLF7/QLs2H87P3JFb7sqLtiNlmxguk8OdFLxUXH3Fd5LFtek3EsMTQHio4Juvt64zzjPsD8DHJThWPPjd1YMmwxKGg1NdzDwF7yd/MPJItFMVrOG58SqlvzkoCTY1CYxijy5by1J2LRbc2yEhqs3hB+fVbLrj9X7X7w32z369gxGofM67NFgZjW0kzCqw6bvb7DNO4vXZPM3+hq1C8sF3CN2v3SjKs4XzufxThS0mjcXJOzLgPHJ6VHVg0NN47RfEtUF8kpsPSzpD4Oebr1wThJ1ptzPEYVimf+xoRndkuXUPtv3PqwC3319rXMSxGuGwpbzZ9K55JSokkPxbuMDbZu0LNx65trFYp3/MMEbaPGZLW52QHhr4i/197OIzZU3pWETAlZiBhsH8zSV/ui6lBwTg96d2se3/mMggLV4+OnrHtNUuWN6NNqbfnaFL4ydhr4YrOwuBJ7exlRqPzoJTvPpZILYz3u+YTuwaKPxrO95xOwOdj7z7zE9lCMY57W947a1dbmd8H8L6ma8gYZeCGkHHh5gODD7Za55HjuveBQefXbNzpdgw8Q6zP7iwMxRpass1EDCvtoR9vv2mWAPGhKyKGNdybO0Ep+uEYI8AJXYXBH4/XwXC+52OK1A9qsXwMnpcMLK16/r4F8FtZ0xVd8wdvqHuZfO5GIjqk9tvq0TXTWm2EmAkmHATyWzOprd2PLNFnvZeQ+fCuQvH6dvop5XNfJqLoA5FrPC/hSD73DRB9vp1+NbemfynffRaR+mo7/QBYNjrqvqOZZDAewxrO576liD7T5hhIq/FJhlX19vyKgN7x+mNg1RrmN29TKEoMV1tXRVJVdQ6A2j4ayXefD1Kn1zpiYCjbPzgmKSZGGOnLfR2g2Ds+weDLw4BnNQvTKOW7jyJSV8fP8zgMKzV3ZpaYsvh7kD5K83LHkEFXxe+gwxyUmp404cg9Zl6ULRS75e+RY7vfDJvEk+q0Q0RmfCdbGIw93bVnJMZQQY3LA+J5MV+cLRQ/lR5vIobVEK83zoSZ9anZwtD3IoYlYfDbTX7DMAgSVCcS09LOwuA2471whSHNWUXEnZVHJnYv1/p74fADJmcmT1oRSweMn3UWBj883nirjsu90zApTsFptsDtLFC6TYOHUuPrOkQdc23VL1ksakksurZiWMO9uTOUojqVGcy3M+MuEBGIZxKoTrUNQn7v5vOLd9XGHjlu5hYwnCvrYqequ5UJdxPDY9COSYmjupa/7SwM/nfje7eOw4psj6BzGVSmKNAyEVgspzMhAJgAUsSgIAj2EpWvNkZKJZTodDU2Pksc3TJIrB8wKTkvZtyaLQwetDbrWOrrKRIQfayV99UXLFtKX9lqG6pzHLU63Er53FeI6MvpMSW7g4A1ILwJoFjNqw7iaz98c9fCxU8ln0sHPjL4kmx/sWZvrRtiVaMz4IbO/uL/JBuVers/QkpdU3kvZgZuJaIG+iS1k5F87q8g2j0mB/MTxLSElcQy0tsbQoe0viw7MHRKctyRed0fgKF+Wb82/CciDLGWoFvMIKKe5H3N+mNdhaFY6JF7EzGsUj53r5gHmEjX7QVGyIQ10R7j6AuxwXyCSHIRw4o67+s5h4A4ropZfylbGKr3CKZWtWLL4siWJSfk4w8s2+pd993n15oJUzv5qJnT0if8cG/PQUphca1dqPWHpw4M/Wy8jTqS77kfhHeMPVOvhqzNJq9bnFQc1rr2I881Y1gr8rm3WER1RmrdRIob6e35NBTitAVmPJktDMbG4srJqerjhpgvDJkvr6lSQu9P5buPV6SuSL6Hz7z7FoXiw/Xv3ZphPXv4Ph0Zp7PL0i+XlTPlShB9KKY7hx8k9+XfkL8ZvWy6ESO6M1iyKmnLSNuwKvuDS1qj97mXnxnc/bqHPbGTTQKdlXCgREN4vveWLRfe+rd212HZUTO36uhwYtuomDQI9FRyr0Dj650Dg7G0Ves7fQhW9/HNoR98scaAI9VycvcRAP2IiJJ5rA92FopxPJg8u7EZVvTpVi8GBljrwWjfQT0iqt3KubPealpmrOI1C9SspMuo0yVUhZn/lC0U4/Qs6StyaGzZubL+kOLPdRaKSUcbVvV1f8iAGvtmmdn30LXFT4ojMU+ZIHBU7HDuZMvu0OH2yjD/GL8b4z52Rw6SPUYdAZVVaJWWdawSk1NMgKd6D8hsoTqGk6JkqPWO49kVhnsPPkEpHXPVpAdJvI9giC3kdRKlzux/tGYITnsaJxqn1Jv7X1L0vcRitRTv293otXbNYsDWto9a+2YMaySf+1nyg2eNT2UHBi9uNkapr+cmAubE91IhIyvn5fY1Dbozuj9OOEnD4QOcku0fvKxdhpVsV8rn5hPRcTHDaiNqvRnDasY0pc90W2b96WxhKDamt7MWI3258wA6o1lbZgxnC4NTm9M7t4hAsxL3Wnqn0swgWgKt52QHhiKmsdEZVmKS6XFjBtGXyxEono9m/khXodg01WU4331iwPo36eDZUl/uSwQ6N8kYs/2DsZe4bg/19lwAhS+O7f+KnaldhhXT7ej3TlUZYZLVi/nOzkJxv2ZrFjMsuTmS78mDEOfCMfixbH/xza02zfC87pnKUHH+GbPuzhaGFpXys/YmMuuDvphfKK8efZOkQpR6c98hRTWdd/mzLz39Ojl1m40jOWymwl+S99w1/uuSke/tbOpWbTYmw4pU3ykdq2qnFYMfzfYXx7yiqUmtmDd7d8swYtWKNX81O1CsU1eE5kzhiqSRu9ZNJGHNm/VOMsw+Aj4+tv58XrZQrEtpaT/Sff0DR8dLWUp7+zTzt7oKxc+t7ZqW+nIrCFTnJZQ+NMIju/oXjeWzVTuOVGzTqTOe+xxsv0Vh8bOtxk5nNgBcp8ZtVAkrXkx9QWdhqClzFunJgBE7P8D8sA5oXtfCwVh6mYiuSZVS4jKz/YNjUmWTh0f6esRLWFH5U2lyE6mEMcNKpeUw455sYfDdEzKsiGn15e4EKBHtrm7o7L+pTrceG2jODGVwTIyaqpMMRk0OGjIfMLVQ/HVdsGpK9Um2Xzp31vQOy/hbciOOJ6FMtBjN7qcZFjMPCqwOQFEQW+uLJYG2m4hiwqYlrDqJqKIWPQqNa6F4M7CqOywI7DPRNqncxPnZQrGlsTpKCH5Dx7vEdQ3Fkuu3d6O9JdpJ3+jsL8YnYfVwaiuXcENEuo+Xf5g2LK8rw1rV232YoVS97ZHR1H4n71/Kd88mUrE3dryPpLYHls99/262ZceqNQNPZfsHKzmtG1slrHCEwF0+svm0G+96qTVT7XmagLqgS2bcT4j29N0++J60eaDWVxTA2TFJQjciBiTSKYBLJWGcQAk7ZLSXQ2KYpHDK2IGMe7P9g3EO6SvCsEqHz96cJhv/jA3wFXtf0w9H4jMUGXGQZ01ULfV2n01K0EDqr1o8Timfu4SIKoY+5gZbgPwsxNssM+m+Orc18y3ZQjEpwq8Lj6p7pkHCaiMWLN6g+Z7TFeH82v9phtXgNVrb2bZwRlTDGk4ipkNAeN3E3fL5nf3FujCFV1LCChHuMbV/UV06TW3Opd7Zc0kZY7BFqXzWid9trEVdXmzFpjizq1CMw2CSfaU94wx8P9s/+InxxhOJ2ZnS8TyBJkdbF1i1Uq/ZthaDtjYS1sre2fuZykgEU9dLaxFTTRrdK+PVMYRmc22q3aQbMh5g4oFsf/G7yVvNtJm1oX9ag3hFGJZMcCQ/6z0gM/ZQVRnLz+97avSI9y1ZIjAs0TU8t+ddykIMNVKDKKl6tP6aBAVk8E+y/cXIQJ9kWMx4PFsYFLUzjvsS1chUqpjEwmLmp//01OjOyfHXhpit2m7MOKyRfPc8kBpY13kysDDbPxjbj6q0axkjJYZtAm5lwCfQR8bGfXUZVhDod2y+YKhOra/NrYFG68Ow8j1/JEJsRA50+N+bDyz6bfMPO3cKEcWII+0kroszonNy17NEtEWNYY36wXZbL1wcRWmvDcNq/MbaYFiMq7KFwRgdpNW+qmSQqIvqNaXG1iJVjgbBzNr8BezAUNY6o2qkjfivGMOKiJ/Gsqms0CM6wNyaThwFlpkqxjnSIc/uml+MvH/CtNi0ziDQDmDcnfQy1EtY+FdnYTB2G0d4WIp+VOcKZywt85p3tooaXleGUGHOGw+tocE9zHy91uHXiQzBchr30gRHe3giGf3czAXPzLcw8e0c6t/pwLhfvDSNKU+vLsMaD15mQzKskXzuL0lIpOR+TBM7Lb2A+frOQvHw8RZFPJubESTTorJ+zC8+9pcXXlfzjDcwLM3fzQ4UT2vKMHu7e0ipmxOHyvhhDRWJsb+rUPzoRHundr/U2/1fTOr9CtibCXukVcXKK/DV2UIxCs0pHTt7J7KNOENCVElNYa9izoCNOhNGeg6yX5Wv/5W9alEMEfOKMqzoBVIiaW2SXI0o/uOMGdYu79gqNpaPt0GSL5hiWI90FgZ3Wzn3/dubpv29dJyRRNN6a/z3bCgje5rQG5NhpW0eAO7o7B+MUQPa3XjSriGFivllgD8sTo6Gj7Gv57Kk0R3YgAyraoccb+5rg4f1ajGsBgM1sLyzfzBKR2p1NSTeM/8hWyhGGSLR95IKHGXmS7OF4v82668RSKAdCWv98NYkjEOZfGwSEknmFuo1UyXtRSIFNqeOZUQUxVa2E4857j5oEw8rjYW1Vkb39ASG87kDCXRDLQ0gZlqM3xH45wC+CqKM/J5mWBLDctBm3dulQyPqGBbwN2a+TlINav3Ec2BeEqz2P7j5dbeW1ubjXpu2G5NhyTxG8rllSfTUiRKBRc2GyW9IR9s3RD1DX5TtH2qIRhe1JTt5qgTlVoKAKztvnW1YI/ncdSCKnS7ax39N5HX6d2BYETx4Prc0uTYTAVOW8rn7iGjPsW+g3vvaYPhnvr2zUBSo34ar1NfzJAGJvMaNz7DGGGu95zepsjdC8dSHKqRfRA5S21AHZucXx1KSagz81WBYMnaUZEsdArA1u4HyHEW+Rh61JMNa1dv9BkXqNkHzlCC3RS8NHl8LLkwxrOb8pUWw39owo3babmyGlc7LY8Y/ymV3r2bpMhUbgoSDkJOOoZG4mWRAaCv1YCSf+y2I3lv/7huQYTF/vKtQvDzZvyTyJuFa/k0YFiQnL+k0iVi7DnPNcjlLvd2XklJ1Rvl0fmxDrFYUnR7uky0srkMkadZXOkRC5tJgdG8D0baUz4nnc1oAzG3lDUxnB4yOulvX9mOjt5VdHYb7NkNQiYJ2M84SATDQms/sGijGDqjK/NtDHN2gElZyY0aeFcLXWuGt19mwers/B6XixORkcGgzqNuENHAXOPz8+mKAt8OsqhLQRkUcFSzxDtMQMTuOZxHvElhfhJAX+4pHTFavI4MOJVCd+pBE92wKxQN9uvLwcyjFrPSepJR4ApvgQq07w0qvlcTmsOZzCfwgE15PRJ9hxp1J28q/C8MSDaB7co94xMcqRlW8P1EUORO9oBhvB9G8pDE/YmzMZ2cLxTjAsrbfRvpyz9aHlrCvGRcr0MMM3oyAIxsPlKjHCW1YE0Bw03C++4TkoSaOLmb8Kgj8v5gWu8z2dgroSwYCN4t2T2eVRMII87clHc4I8DxbugtszIHCJwkkGPsVOT4VoPyqMCzJKyOtRmvR2QJ5YTp8dloPTktYUUoKIHlNJO7YkZdWHVAr1VPK525O5yJJoi4Yp3cWBmM4EIlgDsDFzfuHKtHdG+Gql7AUSOuTp6w1RLKEqEQwO00hktPOiXZeg8G3uXr02KSjYaSvR9IumgLV1fXJfLvk6o19OI0Mq/TRHgFBPFQWp7LbaN/Ows0NhSKG+2a+UcF5Ij1nJo3ICstReI52vfD1NWz1V5thqeo7BXrMCdSK5i/2db/ZQSVZWJ6TpLYJr3EM9A0pKy06E6+3fBtjhvBWDMus5BJGTDJsWTNA8oFfP2WHF5IMpLKstfCpSsGheL2rfQbQ+6W/rxc/ctC21mbmw9JXun3D61ClX9bq8QD8waRUt/YMqxp/yrr9wNHkhJJh+sz8K9Z8cQ27SGwtZOJHdZVXEl5C6UdgLgyldrvlpaEbE+pgjHA6thA8P/DwSfFwiSF/p7dP61NQn6piZWnWvG8zvJ8JN1YbDVbn5zwN0A6yURUraK3P6Jx/0wVtPIpSX/dVBPOY6DnScupelS3c3NTtvKKvex+TaIDAu0jf8cfBqpJGnADzaZVBL44Jw7ZEZdym1l4YR/Ji5m+E7vD5ZmZqSeL/KJobftx15U0nJNut6jv4PhD2VNCVNgEf1LXg5qZVc0rzZn8CSl0qTJmU5KMCWunoHQxd2WS+RpwPOtI3u85u5zPes0V/89qWq3tnn6qVUY0HUhKQOJDtv7lpKshEa1Lqm73aAG1WYVgKQagO61xwk9hZx71ePG7mLh3KWagIe2lE9IoOoNpV60/WWCP4Zlf/4nFRNyqpQkYUjT62ttUPO9on+HXIeq5D6h/C8GU8ZronW7i5Lrp7OD/nRBNGlOoiTzPCW7OFm1slh9OK/MzdDMqcRURH1eavBdEsuirjV9a78hdCPr5z/s1XNiOOQJGTaSw0NO1fa1/Zs4n9Ju9S2ffXrQr949JIxRU4JbqudoAA/OfJhWJsA6yNu3zunN0smx6uHn4y1xey/Tdt1WxeLc+TZggDacyqtBdsIi9hc5tBfW7dimNyrzcdSHR7FJwXXWILCPW7N0Z5seH8nDMJUh2IfcVkIQx/OGVh82DDNAEF/wgkqpzyCNom5l9OHhgcgxdpQnGxRRHxIQTsCcL0aMOCfAI/AqbfavYLzdJual1JwqiabJ2lQAez4p0qG5EkIvn3OsSAJJFLBPw73+QILElI2jRZhdd3XTl0XXI6K/KHnEYKexPrQDEJFzonO3BTS9C/4XkHzVJEJ0LRPkyYXmFY9CJpdTeY5y9b+sTQzsW/R3hopb5uCRqW2LoQJFvaP2Pqlbc/02wDjvTO3o+gPqFJSdK8rRg/nzJwcwNy6ERMR+6PfPSg84nFkG2EYCVIEhdMHgfvKd3n6t7Zc5nMD2nQDKgwAlc0QgQgepQ1/TYwgh+3CoBN9zWS7zmYoT7GivdVLJhc0Yf+sGb6aVdhMDoQR/LdCwkslDQA/p3ApyT7EQA+wDoVFJWgsxm4vavwq7rE9mZ0EUHBVPggyDhQs7ErEW1Twa0TVAT9GGn9awpwSedVQ49ORNfhj3YfrrQ6nIAZBN6+KoEyGI8z6XuZeWFXYXHT4FzB37cUSdK5pO+YxHzP5PmNeaJiC8tkMt9iRUozKwY9ukX/TQ2B5zLXpgyrIfq4wjMa8tHSRkatMUuw2Ev53CmB1nckoXQbI3uFkep858BQQ2ClqJ2WjZ8nCwdI7T8vLL8xCQI4EbFfy/dFktxul64o963DQtC54LYVaztfWWh5Jlw9/NIrhVGenPfy4PlVrXJA1/ZdXmPtadnxM6fjZaADYdjZArCvnTlLdDybRmS/nAixtJ3+1rZNDTElOvdNg9cGabSBoVf3m/QzZS0QS9d2zuO1b2BYTWKHREz/cra/2AAal4bnqDEsqcTDoNdlC4OR+lNFf3yRgDhrPpkT2Kqqb6mvPpt+omTsDUmYTX1tosAmCrz2KNDAsEr53FNENIY1PU6qRIQZrej3tddiVCrYlPI9FxHhtFpqRDqMIZlyIjhQvs/XpvGsa3021KEbJxjvtUfeTTPaRIFNFNiQFKhjWKXe3Lmk6EsxA5og2biUSi+oJZvWUkjEUO+H7sm2mRkD12d+obNQjFSZGmyw73I2CfyVfMFhwcpxpjyXDCpNY4hvSIJs6msTBTZR4LVLgZhhpZEbpbDE6uXLthzPNiK2qmQCaS3WKgZUYy4z0bK6HCbGIZ2FwZuSCJrshTsnc5DS5BIDJgi/in9nPNBZGNzjtUvWTTPbRIFNFNgYFIgZVrr+HLOemy0MxQD4zQavhyjh5zr7ixHUyUgKiTDx7F87+wffJobbnd8+/e44zYHRl4y/ajZWKZ8bTJabGg86ZGMQalOfmyiwiQKvPgUihlUF7oqrlUyEjCnPNKBpJsp0NSIzVl6UQz5Wco4qcMyTBJKjFtXWEpq2RqLG5N/WqISvPlk3zWATBTZRYGNQoFLmK51TpfkDnQPFMRWsycgNIH1VVS/qrzk0TV3twlJf7qpkxZk2KwpfTYSj4ul4etd2YknaIpzjvNmEPglQb2PgsZD5B/C8phhOLfpThmPdBqYfhp4XRye3Nfa/QyPH+lEU7+V6aw1f3OT1toRp7o4gEMy1GF/tFSNDxh6EJO6XfYEx2nStGwUcONYQWF8CLxy3gMy6dd/8qYhhjfT1COzrbhUxqB6fqtljUZyUgxVxZY2EIV3aRzAVatKKZOkegR7OFopxgYWGsl1toClKIJppqjHkyg2UIG05jkTVVwofMD8Col0lQlkzn6PLXlx3cALCG4ZjB8S4MPC8dmvcbci13Lh9ZayVYHoerheXkFppGmUxAAAUR0lEQVTnAR0rynbgstdOIsw6D9PqQcrYTMxXatc/foN3/n+nw0mGY7/MrM/WXtCQU7mxyEAjx/XsAhOJiNfGvLP04CN9Pb8GMFbrrokNqglWekOyqMRr1VWV1frznQND3xzvZeuZKz/UWShOnFs3ToemY84mMobA+KHvuh+rNTUd+xtQ9HkOdG/o+00r26a6jRgWsz5de4EkfdfnzKz/CgoiRsuy4Ovf/fg9GLb1exDKoes3rya8NhNwrEuJ6BPjMCxhZONWHl+b4dJtlW35IP6CdoOL1qef9Xy2koD62rza2mumY7MGn6Zdvw5qeWO+EpV6uz9OSsUloJiDd6fhMJITGM7nrlREffFv3JxplPpylxMoLtPdrOTQqqMP3MHIZJ5O9t+sZl/yfho9IA3xsbbEMh17NYFe9F03gU1U6cXssP8I0IxgNCqHljEy9mXMfK8iOoWBXUC4KRz1jqyqNYaVcQINnQ/L/k/NjH07hfxJ3/drRToypuMUEeKCIHDjmowyjmF3HEUi4TFsgB5hwnmhu6aCRmlm9icTBRBPAfNS1jgKnhdX1nGsyZeFSh8WmJ5SWl+jR3VDBd4qTSbL/EE4GAwLRAPhqNu0yKe0z5j26SB1ZmBoAWj8AQgHMrAsHPUOjfqz7d1MZQxA8+4AuSCcF7ijCQaQ2dG06RomFrSD1aDwk+Go91OVsb8UYZ8BmwH0LAHPBGU3OvyMDvtwYroYzFPldw71iUEQRLjnRsY6XrHaW7O6gwjfYsapoTdaSzcix8ncoTVf6/uulGiHaXf8AqQfD1w3UmGNjBP9HpbdjxuZKJn7DhBvThpzQLg/KHuCNvqP2v4xHOd7RPgfFugkxg3yXHTPsvY2DDqNme8gpb4E5ulEfHkw6p/awBgd538V6AOBW47z/wzHmWOw+rLnjQrjX+M4HZ9lxhkAOwA9SKSPc133sWgox/kxQ78cuHHf25uO8+NA6y/A99NQxltaGfsShHQnSJ3I4N0AuinwRgXLrMYYbdvuuJYIkrMoOsR5ruvG6UCO40hx1MtCkrXhZwJ4R6KMJ2OaZGzBvDoUoBVMfBkxzlDMZ/muf2mz786y7Su1gcPAka16KCx7kmcbAX6qjPNDDX6SCO8CQ2oTPMLsfRBlxMVplWNfqIjmWpLgBdxY9t0TaaS358dQiGBXBfbkO/2DW57TnPNTKd/zkzobklDCD96YroArfaVLqjfLCq+0qw+NkN90E8ylGkHSRVgB/7DO/lsmTHBtwcimWRnnBbD+hO/60YZOXobjHEIKNwajrsSNLTc7nEjCYeAS1nhSKXwHGrcHrisgbWRlHA3Wp/iuf5mVcZjB9wZlL6oiYtr2GaToPL/siif1uXgcs2Nf08SdmvUpBDwLMi4H46+hu2Y2Ojreo4C7oPW3NYW/VFCfIOCIsOzJfF607czNYHO2Zp4TGIFSRjBoB+HCsoc6HHhhL0aH808CpjH4aGgaIYWbNOMKXXbjQ6U2JzujvmaG1pkh4UJN+hkmOimCHtb624HrfxbAtmam419gfpw0vsXEOxGpzzHrbwaeK8xoqmlnJHZuhYYWDPr3EvExzPoEAj8JqIsZ2I2YL9bSpuydb3TYRxHoamK+WoOXEKsjiTATod7H9/27zYz9FQJ9mTX5AN0YcPBV+H5sHjDtjuUAdwZe2QYwycx0RDjrQXk0UjvNDkdSd78njMXssO8BaC9mvlYx/Y7B3wTRqqDsCswMm479MyL6kGb0EEJJ9RuStmHZO9LMmDNBRiVJnPkrGvAU0Xlg/kZQ9uoqE8HMvNcyJD80PDz0vOujeTgdy8C8eeCVLdN2vkmkPsusLyTGkyLRg/iNftmVqutLTcdeU51XpdCIZb3DMtT9mvGB0HXTNuZtrIzznOSmssb3SOmnAPUdBb7VrTJM2848TITNwhB5pbANEV3FjC943uiFjuMcAqgbmcOztdZ3wDC+BPB7Ajfaay+bGft3INpHa5wKFeUFihbB0Dg69Ly6PNXoPTP2XVLNKWScBmhPKXVZyPwQl71II6IOZykBWzH4F6xpCRGfG6XVrvG2jDSJDvsnCnQ0aXzADMMykVoEQlGY0F218tWtSoVHJZGgvltFT4i/tVDzh6YOFAWmpOEq9fXIxxVz3laFNOXBkXz3j0Cqzp7AjGvCwPvi5gtvjU89aSulvyaZhiBFRhuRODhrSmFxfRn4Ftyp4WfHebNFeEQzDg1d98aG+5b1X6ap7g1Cfis87yHZ9Mz4YViuqI4qY3/RAF3glysFaSMmpfnMwPPONzP2OQQ6u3ZPJDmAfhu4bq6OKdr2oYqMX3DIBwZB+Y7kPcpkHmVFU7BmVMo2iZieMTucVaTxad91L3Mcx9Wajvf98sLKh2aeb4E/O+qGkjgefbDVyzAz5n5BOVgS/Z8x9zPIuIGYh4OyF6VPJS6nw7HK0OrSUd+N8bmMjC0n4/Vh2TtapBciHOq7FWYgl2lnziaic+Q32858jYnOTN5XjnMaMT8Tet7PzIx9HgOfCctehFQbPR/RlgfDshfbOS3H+TsTOoKy+zrLsU4Cqcs5oAOCoCwmibrLsDuOVISfypiG3XEEiKUSjxe6ZSnD5Zgdzj+DUXcKgNWmY79EwFO+60WVmy3LejcM9Xu/7ErqmHYcp6QRHTxSJJjMjH0miL4cSdqOs4up8ChzJElHebBGh/0LAh1alcTr5mU6HUuJueR7ZUkGn+44Hcu0Dvb0ff8vjtMRMIfneN6YndRxIjrc4Hne/1iOLZhjLwVlT0q4iVS7q2nQ38Dh+4NycFuKBFuaHc6LrNX3Q3c0Aho07Y4vEOHrQhPTdGaRoRZBB3IAiHQWmk7mViLeX/aolXGeAfOo70YMRSAethCacchHhJ63yMo4JQ7C/WsSL2xbEpsf0NC9YbneZGI4To4UBoNA75mQBLc2O5znGXyUSNpGh72SGC8EZa9Sp9O2d1UG/U2z+0aU8U/V4XhgPkOXPak4TbZtn0ZEX6e6VBweK9IYldlyJs2CwlwCutMbhHV4XHZgkXwoTa90UVYN901d/bfF4mX6oQZVM2rAPhiFkPmaJx588a4a2H8p3/MYEXaWFsThj6cUFtVBp7SaU5PfJ1kZRwyHNcmhrolynFOVwneDUVfghsvRKa3DXOAGUT07I2Mfq0ALUwzri4HnfUNO+ahvhAcF5eB2K+OEvua3wPMayrCbtnOhSCjRG4PvCFzkgfIzlMn8PYrwZ54sgC6K4BFTyJpPMYAHiUjgpUV92EZgP4holaS6u64vEB51RUIlx9rI2NeD8G5iLGXQJGI8HbhunU3Ktu23GsQPBhp7+EkJpsP+AzONhGV3pml3rAT47sAriwpRu7aynI6lvjvaZduZqxm0re+NvrPZWhgZ53KA+8Ky51Tvy8exHDrsDtwgxqg3bft0UnS+0FckVBDODVyvhpeS7tqynA7P18EehmF8hoB/MNPuDC1IAkQKp4ejkeQC07FHQfh2UPYqxWWrB5dfdrO2bW9PRA9q8GMMRO2FrpqQCUXStqx3mKa6Pxh1pXDKv6J90OFcCuYTw7In0l3dZViZeUrRQMQ07MyXDaKvuO4oWZa1l1LmPa47KlKd1AKMLtu2bxL7sOd5nZZjP8BELwVlt4Igm8EOJjlPg6M9lYYCqjAEjYND143MCYaVmasULZCxLcf5JDN9lwhPMmN65b2wksFPiIZgOc6TICgNFqZNIBqVM5k4PJLZmKwIv6zt89pcTccOtMIZetSLgTqr9I3sv2kGLnRngkiq84yM/RKIFoSjbgXFtfpuAbtvQhme2eE8C+ZHwYhQM4giRBIWhlWqgc5LlQxAoF14OybaM+nli1eB+YUw1B+ZumBRnTSQXqh6hsW+uyZ4w0SFJJpB2oyNKx8ZPwCi54nRPYYS2Qh81uwjafWbiLoE2scvu7LZBOIkvmRBCPQP33XllO4S6aZuQ4hdBepHLRiWiMV/EBJLmAQRDquqHK2mogyRtmCcw+C3iMpgdIiIj0fDcsRURDRfVbMBmKb5PsMwbnd1dIqJ3i8fspT7FntBOlRgqunYywFaEjCfKjYwM+OIlPLGoOxul5rQdMdxlmmtj/N9Pz6QzIzzPJj/GLjeIXLyAzQ5afczHbObyCj6Zdex7MwAKz0rKEfifXRZlrU3M1tBENxpZez5zDgycGMJy7IyjsfgrwRlL4YVMR37F0R0aMSwMvbXwPhE4HpNy85HH0rG/j1pQ3S/IPBGZ1sZ63Awie2JmTAUlD2BOhGGtRqEi4KyV6mqXVW1/LLbJetsZZynOQj3DYLgIeEhgHjEo0vH78nuznARVYixbLufCUcErjcGiZQgalXyPp0IedbGUOCPnhoxSahHGH4dk44YB/hl3/XeZmYcqUL9ZFB296/ScAYM9UcOwv8OgiBdvmxrK+M8rzXH6mdNKhX6GRnrBAX1w+o71ooEy36JHBzRHJlvCNzIJivrJgdeZAIxbPsopehqv+xKcYq4iKvp2JrAYk6pg8xWjnWyQer7aQZXpcOXA8/7qunYqwh0ne+6J0aksu3dLEUP+xW6rrQyzgrmcHbgBlJBXg42mQ/RSF9P294YKajK7kundV19p3w4417Vcl1VcDD2XU/vUEOkHO/BlX3d7zWgvk1AXI1kvPbM+F22MJioVD3RzBruR3YsljQixlGh8u432dwVZPQTsE2VgLIxtzU7nH9xOLYhlGOdYpC6JMWwzgmqIr5lWf8FQ90b7fRQzwt9f6xgaHUahuN8QDEf6nuefFiunMJE9JXKqWh9nJW6LAj03vB96Wdby7F/xaE+JQiCP9q2PaIVHgjKXgT8ZmbsC8C0Z+C69dj7GexowXlSa/6wqGSWY30MpH7A4N/H6kbyA3Psh0D0Fp+xC1z3H6Zjn0tEnwfjx77rnlD7aFnzGYHnXQjH2UlUazD/NfrQIkcBL2HNZ4m0aZrmXmQad2nGZaHrniIeWOnPL7tS30+k12WWbV8BRX3Vj/Euw7aPUIquYc1fkDEMx7lEEU5JfwTJ1TRs+3BFxrUAP+27ZXGiTLUyjnyU8MuRHfKF6MOPPk59ceD6kYPCsqyIEfjiQPC8hyuOGDzuu14kIZoZ+6uCyBq47oGmYx5EZCyuta30Z/8/gI5oNTfTsS4iUmKo9wLXk8o8IxVGl3kYinfzGbvCdZ8wbftzIlFWP9TFpmP/kog+4JcjaY7MjHMPAdvW7HqpnbytlXH+pUN9XFg9aCzHORWE7/plVxjUZFHrNNMVoVuO7JaWnbkG0GXf8/KmY32XSJ0aawG2vatFuNpnHAPPe9rKOGuk6LHvRuqpZWacXxKwn9Z8TOh5aQy4KVbGGQHzX3zXE4dKYDrOL8UmWV1zYUgM8P/zy16lfqZtv9VS9CAjPDAoB3eYGedFYl7pu56o0mID/gKIZtNIvieoFZFo9qlzVE4K1wPh5eN5D9PPNjCsNiSsZB9VAP6T68InmvIi/kVnf/FDa82mkg9Epx3/CkSRmikXA89RqA9NePmmGRn7WTAdXjN4Ghmrj5i+X5MUTMcuA3RW4Lqid0dXVdTesdVmNhynp1p9SA4ON5J2WZ/ku34E1GY5zhUgnMjAcgK2ZODOoOweDTHQ2/ZbTUW3g1nwlkQ6nCIw0xETSV2G41yuCCcxWGwHzzLRCBhu4LrNECynWo59F4h2Y+aXQHiUGBkw7vU9L3LQmI7zmYq3jmXODpj/5LueSAKrq/c/S4RvykdKRDYzXx+4kSdOrq0sx/4NiHaRg4I07yd0rklUzDxKRB3M+ns1D5nYvQA6PqgwnlaXYzr2CDF+4nte5MkWyZAYL/uuu1PtITNji8T0/aDsVRL9Rc1TdA9p3tf3/fsiW5Gi28DcBYJLoKms+UuB533NzJjvA6tiAHo7xrx5P2TiDwdlLyqw2uQSZvESc+ygqTURte/XINqjRidwZJ+sxAQC06rrsLPcB5EUs9gJQXhUEARpO95WpmM/w4y5NSO4SFXEdEngRpLuavFQElhszqLuyX4zmHF86HkRYKKVsa8C6Jh4rzEWB64rnr0XzIx5IFjdKqjOzDwM0J+JsJOG/mrYJADXNM19YChRW0VCFS+lAeg5NZXfzDjLmPHz0K06fYTmhAcAfXDgBrcA2M5ynN8wWNZb9lgXg8+lShkvSLmoaQRsxuKChui2eBBa/2GNW75j23UAMFtfhlVb0Qg9kdT+BHoHAbsxaAqBM0yQD+4pP3Q/v8FA/Wx7dwPYORS8bd8X9Th5iaolp6Po0hGyZlU6EENudHJX1TYRmdfUHrQc5ykGxL0+q/V3BpimuT8T7RD6vhhTI9tIfDnOmw3S+6gQf00w0Pi24TgHgzlb9UTV5tYwnGwiJtqpdgKL7QvA863mZTrmLGY1WaSyxPvF9hZ5X8O2309aPxsbY+s729qw7ZmK+dGm87btI0jr54MgkOrh5ehRy3qnQbR7SN7dNZWr2qWoWyKNxSlkLeYt9hlZo1q9TFkfUW3iNamuo3y0EXOtGZmrKnVsFpDDRDx6oeeJF7rmxBBHgRReiFUmAKIqidrSam4Rw9I8Zl9Kzt00zf1Yqe1Dz5MPtbaXxtbXtj9IWq+oqoGitsoay/yTV21/Skm8Ci0r9JK5ybxqoQ2mYduHyQFXfa/6Xmz7bYbiGaGm++B5UkMgeVnyLCm9vGr0l4NSpLdIYmx2iZkjAm6t0DCpzcm3JO9Re1ZMGsJYRSKOa51KnCRrmh76/i+l7UaLNB7O505WRHGoQOB7O6Q9fq1e8j/l94T60NTY/p/ynpveY3wKmI59ExHNGU+d3UTD9iiw0RhWGmZ59eiaaesiqbX3Gq/NVtFGBXby3arr9rU5zU2z2rgUsE3HLtV5JTfueP/RvW80hiX1+CaZxgATzQD4e9n+4isWvv8aWjExlkqQ6Gs1BeM1RKr/2KlYYvxvpur9x77xRnyx/w8+t0ezAp0p7AAAAABJRU5ErkJggg=="
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    d: "M10,0H382a10,10,0,0,1,10,10V321a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    fill: "#f7f7f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(-157 -69.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(240 95)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messaging_application",
    "data-name": "Messaging application",
    transform: "translate(10.429 64.565)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 98.582,
    cy: 98.582,
    r: 98.582,
    transform: "translate(5.215)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2494_",
    d: "M105.089,73.885a79.02,79.02,0,0,0,8.119-5.039A63.83,63.83,0,0,1,137,118.958a4.472,4.472,0,0,1-3.639,4.2,41.332,41.332,0,0,1-23.237-3.639A41.973,41.973,0,0,1,87.171,92.362,40.26,40.26,0,0,1,94.73,81.444c-.28,11.478,6.439,22.677,16.518,28.556a33.743,33.743,0,0,0,16.238,4.479C126.646,98.521,117.967,83.4,105.089,73.885ZM94.17,23.492c8.959-12.038,24.636-18.757,39.474-16.518a4.82,4.82,0,0,1,3.359,4.2,64.048,64.048,0,0,1-25.2,51.232c-5.6,4.759-12.878,7.279-18.2,12.038-8.119,7-14.278,17.077-15.958,27.716-1.4,8.4-.84,16.8-.84,25.2a4.629,4.629,0,0,1-9.239-.28c-.28-10.918,1.12-22.4-3.08-33.035-.28-6.159,0-12.318,0-18.477,2.8,3.919,5.6,8.119,7.279,12.878a68.693,68.693,0,0,1,13.718-19.6v-21A43.692,43.692,0,0,1,94.17,23.492ZM7.1,10.894a3.962,3.962,0,0,1,3.639-3.919,43.1,43.1,0,0,1,26.876,5.6A42.6,42.6,0,0,1,58.336,50.088V81.444A42.361,42.361,0,0,1,13.822,124c-1.96,0-4.479,0-5.6-1.68-1.4-2.52-.84-5.039-.84-7,.84-17.917,9.8-34.995,23.517-46.473,2.8,1.68,5.6,3.639,8.4,5.039a54.861,54.861,0,0,0-22.677,40.594c13.718,0,26.876-9.239,31.075-22.4,2.24-5.879,1.68-12.318,1.96-18.477-3.919-3.639-8.959-5.6-13.438-8.679C18.3,53.168,6.823,32.171,7.1,10.894ZM69.254,63.246c2.24-1.96,5.879-.84,7,1.96,1.4,2.8-1.4,6.719-4.479,6.159C67.854,71.365,65.895,65.486,69.254,63.246Zm-.28-21.557c4.479-2.24,10.358,1.4,10.638,6.439a7.934,7.934,0,0,1-7,8.119c-4.2.56-7.839-3.08-8.119-7.279A7.606,7.606,0,0,1,68.974,41.69Zm1.4-15.4c3.36-1.68,7.559,2.52,5.879,5.879a4.528,4.528,0,0,1-7.839,1.12A4.68,4.68,0,0,1,70.374,26.292ZM96.97,36.65c-3.359,8.119-1.68,17.077-2.24,25.476,5.879-3.36,11.478-6.719,16.238-11.478a56.639,56.639,0,0,0,16.8-35.275C114.327,15.373,101.729,24.332,96.97,36.65Zm-80.348-21A57.922,57.922,0,0,0,27.54,44.769c5.6,7.839,13.718,13.158,21.837,17.637v-14a31.791,31.791,0,0,0-9.239-22.4A32.061,32.061,0,0,0,16.622,15.653Z",
    transform: "translate(34.474 22.162)",
    fill: "#cecece",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(85.155 35.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1237.355,448.2V622.515h-92.4V448.2Z",
    transform: "translate(-1137.683 -436.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1173.06,532.083H1088.1a10.684,10.684,0,0,1-10.672-10.672V345.72a10.684,10.684,0,0,1,10.672-10.672h84.962a10.684,10.684,0,0,1,10.672,10.672V521.411A10.684,10.684,0,0,1,1173.06,532.083ZM1088.1,335.523a10.209,10.209,0,0,0-10.2,10.2V521.411a10.209,10.209,0,0,0,10.2,10.2h84.962a10.208,10.208,0,0,0,10.2-10.2V345.72a10.208,10.208,0,0,0-10.2-10.2Z",
    transform: "translate(-1077.426 -335.048)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1470.724,377.38a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,1470.724,377.38Zm0-4.122a1.823,1.823,0,1,0,1.823,1.823A1.826,1.826,0,0,0,1470.724,373.259Z",
    transform: "translate(-1426.325 -368.721)",
    fill: "#363e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1545.1,384.848h-16.236v-2.436H1545.1Zm-15.761-.475h15.286v-1.487h-15.286Z",
    transform: "translate(-1480.259 -377.312)",
    fill: "#363e44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(20.041 73.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M960.089,599.536h52.093l18.623-.516-9.89,5.452V621.2H960.089Z",
    transform: "translate(-959.852 -598.782)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1018.948,619.323H958.122a.237.237,0,0,1-.237-.237V597.417a.237.237,0,0,1,.237-.237h52.093l18.618-.365a.237.237,0,0,1,.119.445l-9.767,5.384v16.441A.237.237,0,0,1,1018.948,619.323Zm-60.588-.475h60.351V602.5a.237.237,0,0,1,.123-.208l9.048-4.987-17.661.346H958.36Z",
    transform: "translate(-957.885 -596.815)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(5.033 4.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1055.971,723.772h-48.253a.237.237,0,1,1,0-.475h48.253a.237.237,0,0,1,0,.475Z",
    transform: "translate(-1007.174 -714.311)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1056.994,767.694h-49.275a.237.237,0,0,1,0-.475h49.275a.237.237,0,0,1,0,.475Z",
    transform: "translate(-1007.174 -753.504)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1053.121,640.321h-48.253a.237.237,0,1,1,0-.475h48.253a.237.237,0,1,1,0,.475Z",
    transform: "translate(-1004.631 -639.846)",
    fill: "#554494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1054.144,684.243h-49.275a.237.237,0,1,1,0-.475h49.275a.237.237,0,1,1,0,.475Z",
    transform: "translate(-1004.631 -679.039)",
    fill: "#554494"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(0 75.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(9.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(15.754 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M3828.851,2251.237c-2.255-1.386-2.843-4.669-1.667-7.04a8.633,8.633,0,0,1,6.333-4.3,12.185,12.185,0,0,1,10.546,3.324c1.464,1.464,2.66,3.385,4.626,4.037,1.728.573,3.621.005,5.429.213a8.189,8.189,0,0,1,5.794,4.05,17.682,17.682,0,0,1,2.141,6.943c.3,2.22.5,4.658,2.071,6.258,1.527,1.56,3.909,1.861,5.8,2.959a7.873,7.873,0,0,1,2.5,10.719c-.725,1.091-1.773,2.1-1.84,3.406-.061,1.194.726,2.245,1.1,3.38a5.315,5.315,0,0,1-4.45,6.665c-1.551.112-3.222-.469-4.6.246s-1.861,2.383-2.727,3.662a6.645,6.645,0,0,1-8.071,2.211c-1.15-.543-2.241-1.451-3.508-1.347s-2.245,1.2-3.487,1.458c-1.626.339-3.192-.839-4.181-2.173s-1.688-2.913-2.945-4c-1.646-1.421-3.934-1.745-6-2.423a16.823,16.823,0,0,1-9.844-23.426",
    transform: "translate(-3820.153 -2239.726)",
    fill: "#1a2e35"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(47.667 39.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M4020.843,2485.391a4.569,4.569,0,0,1,1.8-1.22l-.139-.007a2.672,2.672,0,0,1,.387-.071,1.8,1.8,0,0,1,1.42.154h-.014a3.355,3.355,0,0,1,1.858,1.571,3.97,3.97,0,0,1-.408,4.1,3.035,3.035,0,0,1-5.584-.961A3.768,3.768,0,0,1,4020.843,2485.391Z",
    transform: "translate(-4019.986 -2484.018)",
    fill: "#375a64"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(16.425 11.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M3827.372,2367.961l-3.013-43.557a3.7,3.7,0,0,1,3.147-3.893l19.408-5.8c6.255-.935,10.767,6.623,11.436,12.912.743,6.988,1.375,15.548.77,20.812-1.216,10.583-9.848,12.31-9.848,12.31,0-.035.094,10.759.213,14.581l2.575,11.815Z",
    transform: "translate(-3824.352 -2314.628)",
    fill: "#e2a18d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(11.251 42.211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M3908.409,2582.134a25.258,25.258,0,0,1-13.608-3.191s3.159,7.778,13.638,6.341Z",
    transform: "translate(-3894.801 -2578.943)",
    fill: "#d19484"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(24.799 6.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M3909.412,2293.417a7.224,7.224,0,0,0-2.833-3.939,26.806,26.806,0,0,1-2.361-1.328c-1.538-1.2-1.921-3.335-2.885-5.034a7.943,7.943,0,0,0-6.109-3.926c-2.087-.183-4.225.474-6.264-.008-1.507-.356-2.833-1.312-4.358-1.579-2.97-.52-5.693,1.647-7.81,3.795.023,2.121,1.733,3.514,3.38,4.851a7.353,7.353,0,0,0,5.978,1.485c1.614-.32,3.376-1.164,4.79-.322,1.487.885,1.58,3.105,2.9,4.221,1.892,1.594,4.839.029,7.22.7,1.839.516,3.008,2.249,4.246,3.7s3.08,2.827,4.9,2.257A21.5,21.5,0,0,0,3909.412,2293.417Z",
    transform: "translate(-3876.791 -2277.524)",
    fill: "#1a2e35"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(0 6.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M3756.549,2289.844c-1.333-.36-4.063-1.181-4.793-2.322a8.117,8.117,0,0,0-7.12-3.954,6.7,6.7,0,0,0-5.955,5.384,9.635,9.635,0,0,0-8.2,5.451,10.105,10.105,0,0,0-.508,1.244,7.329,7.329,0,0,0-.4,6.16c.477,1.193,1.28,2.516.679,3.651-.611,1.156-2.2,1.215-3.428,1.659a4.867,4.867,0,0,0-2.986,5.48,5.937,5.937,0,0,1,.422,2.389,5.221,5.221,0,0,1-1.4,2.09,6.057,6.057,0,0,0,3.7,9.806,7.82,7.82,0,0,1,2.8.594c.946.563,1.373,1.686,2.047,2.556a5.225,5.225,0,0,0,5.687,1.69,4.755,4.755,0,0,0,1.129-.589,3.751,3.751,0,0,0,3.345,1.424l-.714-22.169a1.836,1.836,0,0,0,1.36,1.033c3.571.753,3.984-6.589,3.161-8.565a20.7,20.7,0,0,0,3.516-3.807,14.924,14.924,0,0,0,1.533-7.219C3751.7,2291.887,3757.135,2290,3756.549,2289.844Z",
    transform: "translate(-3721.505 -2283.552)",
    fill: "#1a2e35"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(13.751 33.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M3814.2,2451.462c-.146-2.252-2.91-2.694-4.848-1.536-1.063.636-1.865,1.894-1.732,4.286.356,6.377,6.685,4.7,6.686,4.521C3814.309,2458.619,3814.373,2454.1,3814.2,2451.462Z",
    transform: "translate(-3807.608 -2449.307)",
    fill: "#e2a18d"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(15.382 35.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M3820.81,2467.675c-.029-.019-.107.084-.29.181a1.11,1.11,0,0,1-.829.063,2.752,2.752,0,0,1-1.41-2.4,3.673,3.673,0,0,1,.222-1.608,1.284,1.284,0,0,1,.788-.9.567.567,0,0,1,.673.268c.1.174.062.3.1.313.019.015.131-.115.065-.375a.709.709,0,0,0-.273-.385.842.842,0,0,0-.624-.128,1.564,1.564,0,0,0-1.105,1.053,3.775,3.775,0,0,0-.286,1.8,2.888,2.888,0,0,0,1.775,2.663,1.19,1.19,0,0,0,1.006-.225C3820.807,2467.83,3820.833,2467.686,3820.81,2467.675Z",
    transform: "translate(-3817.824 -2462.695)",
    fill: "#d19484"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(11.412 11.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M3807.784,2312.952a3.81,3.81,0,0,0-1.257,1.084,5.887,5.887,0,0,0-.405,4.42l.037.16-.157.042a6.172,6.172,0,0,0-4.058,3.682,4.812,4.812,0,0,0-.307,1.562,9.369,9.369,0,0,0,.224,1.683,12.719,12.719,0,0,1,.27,1.812,3,3,0,0,1-.478,1.89,7.746,7.746,0,0,1-3.131,2.425,10.738,10.738,0,0,0-2.935,1.984,7.974,7.974,0,0,0-2.3,5.382,8.325,8.325,0,0,0,.9,3.931c.437.865.8,1.275.763,1.3-.012.01-.106-.087-.277-.283a6.8,6.8,0,0,1-.641-.936,8.11,8.11,0,0,1-1.062-4.018,8.209,8.209,0,0,1,2.327-5.668,10.985,10.985,0,0,1,3.024-2.083,7.429,7.429,0,0,0,2.956-2.275c.693-.979.358-2.239.156-3.379a9.668,9.668,0,0,1-.222-1.768,5.177,5.177,0,0,1,.349-1.708,6.467,6.467,0,0,1,4.366-3.856l-.12.2a5.929,5.929,0,0,1,.577-4.607,2.683,2.683,0,0,1,.986-.829A1.539,1.539,0,0,1,3807.784,2312.952Z",
    transform: "translate(-3792.963 -2312.949)",
    fill: "#375a64"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(15.163 41.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M3817.309,2501.829a4.562,4.562,0,0,1,1.8-1.22l-.139-.006a2.658,2.658,0,0,1,.387-.072,1.8,1.8,0,0,1,1.42.155h-.013a3.356,3.356,0,0,1,1.858,1.57,3.972,3.972,0,0,1-.408,4.1,3.035,3.035,0,0,1-5.584-.961A3.766,3.766,0,0,1,3817.309,2501.829Z",
    transform: "translate(-3816.452 -2500.456)",
    fill: "#375a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(118.254 73.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M4400.916,2719.457l4.348-1.667a28.473,28.473,0,0,1,1.975-4.9,39.576,39.576,0,0,1,5.232-4.615c.246-.093,3-6.277,4.261-6.076a2.065,2.065,0,0,1,1.771,2.762c-.352,1.678-3.136,5.025-2.364,5.582a5.637,5.637,0,0,0,2.027.758s.341-1.928,1.4-2.552,2.264.412,2.264.412l.032.831,1.045-.956s1.1-3.872,2.765-3.854a6.782,6.782,0,0,1,1.644-2.209,1.434,1.434,0,0,1,2.208.646h0l-2.99,8.773-8.224,9.059s-3.855,1.481-4.837,1.936-5.441,3.541-7.413,4.2-4.264,1.664-4.264,1.664Z",
    transform: "translate(-4400.916 -2702.19)",
    fill: "#e2a18d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(3.602 14.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M4431.406,2792.554a5.025,5.025,0,0,0-1.562-.16,7.226,7.226,0,0,0-3.723.818,4.516,4.516,0,0,0-1.542,1.486,7.086,7.086,0,0,0-.736,1.561,4.67,4.67,0,0,0-.357,1.529,7.684,7.684,0,0,0,.636-1.421,5.568,5.568,0,0,1,2.212-2.79,8,8,0,0,1,3.518-.884A6.9,6.9,0,0,0,4431.406,2792.554Z",
    transform: "translate(-4423.475 -2792.394)",
    fill: "#d19484"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(12.955 7.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M4484.417,2751.474c.064-.092-.384-.5-1.083-.707s-1.3-.118-1.294-.005.54.216,1.172.409S4484.353,2751.575,4484.417,2751.474Z",
    transform: "translate(-4482.04 -2750.641)",
    fill: "#d19484"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(21.303 2.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M4537.66,2727.531a8.927,8.927,0,0,1,.192-1.9c.171-1.183.439-2.839.768-4.739l.123.248c-.29-.133-.641-.342-.9-.424a1.151,1.151,0,0,0-.876.112,2.536,2.536,0,0,0-1.017,1.229,9.163,9.163,0,0,0-.539,1.518c-.237,1.014-.4,1.956-.542,2.74a15.716,15.716,0,0,1-.532,2.536,12.526,12.526,0,0,1,.2-2.587c.1-.795.227-1.738.447-2.788a8.889,8.889,0,0,1,.542-1.613,2.938,2.938,0,0,1,1.221-1.457,1.618,1.618,0,0,1,1.228-.143,8.76,8.76,0,0,1,.978.466l.156.073-.033.175c-.354,1.9-.68,3.541-.932,4.709A8.865,8.865,0,0,1,4537.66,2727.531Z",
    transform: "translate(-4534.313 -2720.195)",
    fill: "#d19484"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(13.84 6.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M4487.586,2752.724c-.02,0-.007-.134.038-.377a5.213,5.213,0,0,1,.354-1.007,12.865,12.865,0,0,1,2.158-3.146l-.047.079c.569-1.685.052-4.123,1.577-6.3a2,2,0,0,1,1.585-.7,2.934,2.934,0,0,1,1.535.538l.109.075-.017.136c-.306,2.464-.589,4.594-.808,6.1a3.969,3.969,0,0,1-.553,1.718c-.214.365-.368.538-.39.523a3.2,3.2,0,0,1,.25-.593,4.305,4.305,0,0,0,.406-1.7c.139-1.519.361-3.648.638-6.1l.093.211a2.52,2.52,0,0,0-1.278-.436,1.524,1.524,0,0,0-1.215.55,3.612,3.612,0,0,0-.711,1.475,13.982,13.982,0,0,0-.343,1.612c-.091.536-.116,1.03-.178,1.56a9.384,9.384,0,0,1-.321,1.454l-.014.044-.033.035a14.722,14.722,0,0,0-2.239,2.972C4487.74,2752.226,4487.641,2752.737,4487.586,2752.724Z",
    transform: "translate(-4487.577 -2741.266)",
    fill: "#d19484"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(0 60.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(26.395 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M3825.715,2622.19c.262-.377,2.007-3.748,2.007-3.748l9.9,8.531s9.7,8.125,9.7,7.6l1.548-7.816,1.907-7.111,3.559,5.378s11.183,21.924,11.183,22.187,6.921,22.954,6.921,22.954l-1.489,9.2-.175,32.591-20.852-.876-4.118-6.571-7.1-41.791Z",
    transform: "translate(-3825.715 -2618.443)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(43.976 87.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M3944.235,3163.625h22.215l3.52,14.93h-34.163Z",
    transform: "translate(-3935.806 -3163.625)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(12.034 2.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M3775.463,2714.522c-.7-10.7-.406-30.9-4.5-41.432s-20.545-36.42-20.545-36.42l-4.038,6.277-10.586,3.973,14.361,58.214s-5.531,13.024-8.165,20.633c-.787,2.274-1.849,6.135-3.013,9.987h36.342C3775.637,2727.287,3775.793,2719.579,3775.463,2714.522Z",
    transform: "translate(-3735.79 -2636.67)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(65.204 8.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M4124.822,2688.049l-28.015,15.573-19.415-27.7c-.052-.071-.107-.146-.167-.225-2.209-2.924-4.38-6.143-7.955-6.946l-.541-.122,1.039,33.162s13.8,15.217,21.544,21.509c2.3,1.874,8.146.7,10.929-.833,11.15-6.153,30.193-21.93,30.193-21.93Z",
    transform: "translate(-4068.729 -2668.625)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(52.062 1.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M4008.8,2699.644s2.041-15.83,2.71-19.8c3.5-20.8-11.93-43.807-11.93-43.807l-7.055-1.167-6.087-5.027,2.688,7.51s8.841,24.733,10.6,32.635,2.634,32.192,2.908,31.606c.161-.345,1.225,14.665,2.56,28.424h14.976Z",
    transform: "translate(-3986.436 -2629.838)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(58.148 6.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M4039.514,2708.468a2.914,2.914,0,0,1,0-.515c.02-.368.046-.857.08-1.469q.03-.483.066-1.06,0-.586,0-1.264c0-.906.022-1.939-.067-3.077a64.115,64.115,0,0,0-3.466-17.424,60.146,60.146,0,0,0-2.811-6.917l0-.008,0-.005a59.292,59.292,0,0,0-3.244-6.323c-1.071-1.862-2.059-3.483-2.886-4.825l-1.956-3.13-.521-.837a1.657,1.657,0,0,1-.166-.3,1.527,1.527,0,0,1,.213.268l.565.808c.487.71,1.184,1.753,2.037,3.081s1.863,2.938,2.954,4.794a57.164,57.164,0,0,1,3.306,6.339l-.006-.013a58.392,58.392,0,0,1,2.844,6.957,61.621,61.621,0,0,1,3.384,17.524c.073,1.145.036,2.182.016,3.091q-.016.679-.031,1.268-.052.578-.1,1.062c-.061.612-.108,1.1-.145,1.468A2.847,2.847,0,0,1,4039.514,2708.468Z",
    transform: "translate(-4024.545 -2661.315)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(34.431 13.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M3889.423,2703.391a1.546,1.546,0,0,1-.394-.173l-1.068-.564-3.767-2.085.221-.111c-.184,1.693-.5,3.671-.806,5.779-.126.858-.244,1.7-.341,2.5l-.038.309-.236-.2c-2.015-1.714-3.768-3.224-5.009-4.312l-1.449-1.29a3.166,3.166,0,0,1-.5-.5,3.219,3.219,0,0,1,.573.408l1.513,1.214c1.28,1.043,3.059,2.52,5.085,4.221l-.273.108c.092-.807.208-1.646.334-2.507.312-2.112.638-4.084.85-5.764l.028-.225.193.114,3.706,2.191,1.027.635A1.5,1.5,0,0,1,3889.423,2703.391Z",
    transform: "translate(-3876.037 -2700.198)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(47.996 6.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M3966.552,2659.653a4.456,4.456,0,0,1,.031.892c-.012.64-.027,1.454-.044,2.427-.052,2.05-.147,4.88-.273,8,0,.077-.006.153-.009.228l-.022.546-.293-.461-3.746-5.9.235-.029-1.025,2.82a6.24,6.24,0,0,1-.428,1.024,6.14,6.14,0,0,1,.289-1.072l.916-2.857.084-.261.151.232,3.812,5.861-.314.085c0-.074.006-.151.01-.228.126-3.125.259-5.953.373-8,.061-.971.112-1.784.152-2.423A4.492,4.492,0,0,1,3966.552,2659.653Z",
    transform: "translate(-3960.974 -2659.653)",
    fill: "#1a2e35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(0 13.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M3672.468,2700.854a15.889,15.889,0,0,0-2.458,1.891,16.745,16.745,0,0,0-4.281,6.744c-1,2.854-1.99,6.367-2.565,8.579l-2.679,40.633a23.909,23.909,0,0,0,1.708,10.575l8.3,20.412h17.889l-9.656-27.309,3.307-30.127Z",
    transform: "translate(-3660.434 -2700.854)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(23.054 8.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M3804.8,2671.743l3.935,11.8h4.192l-2.721,1.732,21.514,41.118",
    transform: "translate(-3804.8 -2671.743)",
    fill: "#493d84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M3831.714,2726.395a.631.631,0,0,1-.095-.143l-.248-.437-.924-1.7-3.34-6.266-10.906-20.733-6.142-11.77-.067-.129.122-.077,2.725-1.724.08.274-4.192-.015h-.1l-.03-.091-2.816-8.633c-.319-1.008-.572-1.8-.753-2.373l-.187-.622a.975.975,0,0,1-.052-.217.925.925,0,0,1,.089.2l.224.61.821,2.35,2.927,8.6-.127-.091,4.192-.015.512,0-.432.277-2.716,1.739.055-.206,6.167,11.756,10.816,20.781,3.243,6.317.866,1.726.218.453A.633.633,0,0,1,3831.714,2726.395Z",
    transform: "translate(-3804.792 -2671.743)",
    fill: "#554494"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(15.116 18.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(0.002 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M3755.1,2736.877a26.241,26.241,0,0,1,5.805,22.33",
    transform: "translate(-3755.102 -2736.877)",
    fill: "#554494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M3760.9,2759.2c-.069-.013.225-1.323.349-3.472a27.293,27.293,0,0,0-.055-3.772,27.1,27.1,0,0,0-2.314-8.9,27.286,27.286,0,0,0-1.789-3.322c-1.155-1.817-2.05-2.817-2-2.863a4.935,4.935,0,0,1,.647.684,10.317,10.317,0,0,1,.7.857c.256.346.567.728.854,1.189a24.66,24.66,0,0,1,1.874,3.322,25.72,25.72,0,0,1,2.342,9.008,24.681,24.681,0,0,1-.018,3.814c-.026.543-.112,1.028-.167,1.455a10.153,10.153,0,0,1-.192,1.088A4.9,4.9,0,0,1,3760.9,2759.2Z",
    transform: "translate(-3755.088 -2736.873)",
    fill: "#1a2e35"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(18.159 105.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M3783.931,2954.894a.642.642,0,0,1-.062-.136l-.158-.407c-.139-.377-.334-.9-.583-1.577l-2.1-5.824-6.873-19.322-.01-.027,0-.03.073-.666c.907-8.128,1.728-15.484,2.324-20.829.308-2.65.558-4.8.733-6.309.091-.73.162-1.3.212-1.714l.062-.445a.676.676,0,0,1,.029-.151.7.7,0,0,1,0,.154c-.01.115-.021.263-.036.448-.039.411-.094.986-.164,1.719-.156,1.51-.379,3.664-.652,6.318-.578,5.347-1.372,12.707-2.25,20.837-.025.228-.05.455-.073.666l-.007-.057,6.8,19.347,2.026,5.851.538,1.593c.055.172.1.309.134.416A.689.689,0,0,1,3783.931,2954.894Z",
    transform: "translate(-3774.144 -2897.457)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(69.907 79.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M4098.178,2734.695a39.688,39.688,0,0,1,2.9,5.524c.417.872.762,1.874,1.185,2.927.355,1.078.782,2.216,1.1,3.453.371,1.223.655,2.534.963,3.888q.188,1.025.381,2.085c.131.705.206,1.431.313,2.159a69.718,69.718,0,0,1,.2,15.057c-.107.956-.2,1.822-.29,2.588s-.2,1.411-.279,1.945l-.2,1.226a.217.217,0,1,1-.051-.008q.055-.456.148-1.232c.06-.536.168-1.186.235-1.948s.159-1.631.251-2.586a73.356,73.356,0,0,0-.273-15.008c-.106-.725-.18-1.448-.31-2.15s-.253-1.4-.376-2.076c-.3-1.349-.582-2.656-.944-3.875-.314-1.233-.731-2.368-1.077-3.445-.413-1.052-.747-2.054-1.151-2.927l-.545-1.259c-.176-.4-.367-.758-.531-1.1-.335-.687-.618-1.283-.886-1.75l-.586-1.093A2.656,2.656,0,0,1,4098.178,2734.695Z",
    transform: "translate(-4098.178 -2734.695)",
    fill: "#1a2e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(92.472 103.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M4240.558,2895.659a4.611,4.611,0,0,1-.515-1.216,12.173,12.173,0,0,1-.279-6.318,4.574,4.574,0,0,1,.406-1.256,12.537,12.537,0,0,1-.229,1.292,14.573,14.573,0,0,0,.276,6.232A12.231,12.231,0,0,1,4240.558,2895.659Z",
    transform: "translate(-4239.475 -2886.868)",
    fill: "#1a2e35"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2494_2",
    "data-name": "XMLID_2494_",
    d: "M31.966,23.636a20.053,20.053,0,0,0,2.06-1.279,16.2,16.2,0,0,1,6.039,12.717,1.135,1.135,0,0,1-.924,1.066,10.489,10.489,0,0,1-5.9-.924,10.652,10.652,0,0,1-5.826-6.892,10.217,10.217,0,0,1,1.918-2.771A8.381,8.381,0,0,0,33.529,32.8a8.563,8.563,0,0,0,4.121,1.137A13.969,13.969,0,0,0,31.966,23.636ZM29.2,10.848A10.766,10.766,0,0,1,39.213,6.656a1.223,1.223,0,0,1,.853,1.066,16.254,16.254,0,0,1-6.394,13c-1.421,1.208-3.268,1.847-4.618,3.055A12.05,12.05,0,0,0,25,30.812a38.5,38.5,0,0,0-.213,6.394,1.175,1.175,0,0,1-2.345-.071c-.071-2.771.284-5.684-.782-8.384-.071-1.563,0-3.126,0-4.689a13.4,13.4,0,0,1,1.847,3.268,17.433,17.433,0,0,1,3.481-4.973V17.029A11.088,11.088,0,0,1,29.2,10.848ZM7.1,7.65a1,1,0,0,1,.924-.995,10.939,10.939,0,0,1,6.821,1.421A10.81,10.81,0,0,1,20.1,17.6v7.957a10.75,10.75,0,0,1-11.3,10.8c-.5,0-1.137,0-1.421-.426a3.222,3.222,0,0,1-.213-1.776,16.623,16.623,0,0,1,5.968-11.794c.71.426,1.421.924,2.131,1.279a13.923,13.923,0,0,0-5.755,10.3A8.416,8.416,0,0,0,17.4,28.254a14.857,14.857,0,0,0,.5-4.689,28,28,0,0,0-3.41-2.2A16.5,16.5,0,0,1,7.1,7.65ZM22.872,20.936A1.151,1.151,0,1,1,23.511,23,1.165,1.165,0,0,1,22.872,20.936ZM22.8,15.466A1.957,1.957,0,0,1,25.5,17.1a2.014,2.014,0,0,1-1.776,2.06,1.935,1.935,0,0,1-.924-3.694Zm.355-3.908a1.153,1.153,0,1,1-.5,1.776A1.188,1.188,0,0,1,23.156,11.558Zm6.749,2.629c-.853,2.06-.426,4.334-.568,6.465a18.777,18.777,0,0,0,4.121-2.913,14.374,14.374,0,0,0,4.263-8.952A8.583,8.583,0,0,0,29.906,14.187ZM9.515,8.858a14.7,14.7,0,0,0,2.771,7.389,16.082,16.082,0,0,0,5.542,4.476V17.171a8.068,8.068,0,0,0-2.345-5.684A8.136,8.136,0,0,0,9.515,8.858Z",
    transform: "translate(365.007 217.511)",
    fill: "#f26149",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(267.53 152.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 23.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M398.085,653.428V670a21.258,21.258,0,0,0,21.258,21.258h0A21.258,21.258,0,0,0,440.6,670v-16.57Z",
    transform: "translate(-397.846 -653.19)",
    fill: "#ccf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M417.376,689.529a21.521,21.521,0,0,1-21.5-21.5v-16.57a.239.239,0,0,1,.239-.239h42.516a.238.238,0,0,1,.238.239v16.57A21.521,21.521,0,0,1,417.376,689.529ZM396.357,651.7v16.332a21.019,21.019,0,0,0,42.039,0V651.7Z",
    transform: "translate(-395.88 -651.224)",
    fill: "#363e44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M455.6,454.57a.238.238,0,0,1-.239-.239,18.678,18.678,0,0,0-37.355,0,.239.239,0,1,1-.477,0,19.155,19.155,0,1,1,38.309,0A.239.239,0,0,1,455.6,454.57Z",
    transform: "translate(-415.186 -435.177)",
    fill: "#363e44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M519.812,735.687l-8.623-7.839,2.664-3.283,5.467,4.369,8.579-12.451,3.49,2.4Z",
    transform: "translate(-498.716 -686.052)",
    fill: "#f26149"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "hy_300x47_1_",
    "data-name": "hy_300x47 (1)",
    width: 179,
    height: 28,
    transform: "translate(108 31)",
    fill: "url(#pattern)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRegistrationMobile);
export default __webpack_public_path__ + "static/media/phone-registration-mobile.4e52c746152c7828707330933c08805c.svg";
export { ForwardRef as ReactComponent };